<template>
  <div v-if="myloading">
    <div class="common-form">添加协议</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="协议名称">
        <el-input class="max-w460" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="协议内容：">
        <div class="edit_container">
          <Uediter :text="form.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>

      <!-- <el-form-item label="排序">
        <el-input class="max-w460" v-model="form.sort" type="number"></el-input>
      </el-form-item> -->

      <el-form-item>
        <el-button type="primary" @click="onSubmit">编辑协议</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
import SettingApi from "@/api/setting.js";
import Uediter from "@/components/UE.vue";
export default {
  components: {
    Uediter
  },
  data() {
    return {
      form: {
        title: "",
        content: "",
        
      },
      myloading:false,
      /*富文本框配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      is_upload: false,
      config: {
        total: 9,
        fileType: "image"
      }
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.getData();
  },

  methods: {
       /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.content = e;
    },
    // 查询详情
    getData: function() {
      let self = this;
      SettingApi.privacyindex(
        {
          id: self.id
        },
        true
      )
        .then(res => {
        
          // self.loading = false;
          self.form = res.data;
         
         self.myloading=true
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 修改
    onSubmit() {
      console.log(11111, this.form);
      //
      let self = this;
      SettingApi.privacyedit(self.form, true)
        .then(res => {
          if (res.code == 1) {
            self.$message(res.msg);
          }
          // self.loading = false;
          console.log(res);
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped lang=''>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/policy/edit.vue